<template>
  <div class="delete-employee" />
</template>

<script>
export default {
  name: 'SecondaryDelete',
  mounted() {
    this.$buefy.dialog.confirm({
      title: 'Borrar usuario',
      message: '¿Estas seguro de borrar este usuario?',
      confirmText: 'Borrar',
      type: 'is-danger',
      hasIcon: true,
      onConfirm: () => {
        this.$store.dispatch('users/deleteSingleSecondary', this.$route.params.secondaryId).then(() => {
          this.$success({ message: 'El usuario se eliminó correctamente' });
        }).catch(() => {
          this.$danger({ message: 'Ocurrió un error al momento de borrar' });
        });
        this.$router.push({ name: 'SecondaryUsers', query: { page: 1, size: 20 } });
      },
      onCancel: () => {
        this.$router.push({ name: 'SecondaryUsers', query: { page: 1, size: 20 } });
      },
    });
  },
};
</script>

<style scoped>
</style>
